import filmsilver from "../../fotos/filmsilver.jpg"
import logoInst from "../../fotos/logos/logoinsta.jpg"
import logolensun from "../../fotos/logos/logolensun.png"
import insta2 from "../../fotos/logos/insta2.svg"
import optimizarlogo from "../../fotos/logos/optimizar.png"
import insta3 from "../../fotos/logos/insta2.png"
import telefono1 from "../../fotos/logos/telefono1.png"
import email1 from "../../fotos/logos/email1.svg"
import email2 from "../../fotos/logos/email2.png"
import arroba from "../../fotos/logos/arroba.png"
import insta4 from "../../fotos/logos/insta3.png"
import optiTecno from "../../fotos/logos/Logo-optimizar-tecno.jpg"
import insta5 from "../../fotos/logos/insta4.jpeg"
import wsp from "../../fotos/logos/wsp.png"
import LogoOptimizar1 from "../../../inicio/foto/logo-limpio.png"
import Logolimpio from "../../fotos/logos/logo-limpio.png"
import MaxxaBateria7 from "../../fotos/productos/bateria7g.jpeg"
import Atras from "../../fotos/iconovolver.png"
import Correo from "../../fotos/logos/correo.png"
import Home from "../../fotos/logos/home.png"

const productos = [
    {
        "id":0,
        "img": filmsilver

    },
    {
        "id":1,
        "img": logoInst
    },
    {
    "id":2,
    "img": logolensun
    },
    {
        "id":3,
        "img": insta2
    },
    {
        "id":4,
        "img": optimizarlogo
    },
    {
        "id":5,
        "img": insta3
    },
    {
        "id":6,
        "img": telefono1
    },
    {
        "id":7,
        "img": email1
    },
    {
        "id":8,
        "img": email2
    },
    {
        "id":9,
        "img": arroba
    },
    {
        "id":10,
        "img": insta4
    },
    {
        "id":11,
        "img": optiTecno
    },
    {
        "id":12,
        "img": insta5
    },
    {
        "id":13,
        "img": wsp
    },
    {
        "id":14,
        "img": LogoOptimizar1
    },
    {
        "id":15,
        "img": Logolimpio
    },
    {
        "id":16,
        "img": MaxxaBateria7
    },
    {
        "id":17,
        "img": Atras
    },
    {
        "id":18,
        "img": Correo
    },
    {
        "id":19,
        "img": Home
    }
]
export default productos